import React from "react";
import "./Carousel.css"; // Ensure this file has the necessary styles

const Carousel = () => {
  return (
    <div className="carousel,section, advantages">
    <div id="homeCarousel" className="carousel slide" data-bs-ride="carousel">
      {/* Indicators */}
      <div className="carousel-indicators">
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="0"
          className="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#homeCarousel"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>

      {/* Carousel Items */}
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img
            src="/images/acurate.png"
            className="d-block w-100"
            alt="First Slide"
          />
          <div className="carousel-caption d-none d-md-block">
            <h5>Welcome to Omega review solutions</h5>
            <p>Your trusted source for reviews.</p>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="/images/care-connection-device-diagnosis.jpg"
            className="d-block w-100"
            alt="Second Slide"
          />
          <div className="carousel-caption d-none d-md-block">
            <h5>Home health coding is the process of using medical codes to represent home health procedures and services</h5>
            <p>Helping you make informed decisions.</p>
          </div>
        </div>
        <div className="carousel-item">
          <img
            src="/images/image2c.jpeg"
            className="d-block w-100"
            alt="Third Slide"
          />
          <div className="carousel-caption d-none d-md-block">
            <h5>Join Our Community</h5>
            <p>Connect and share your experiences.</p>
          </div>
        </div>
      </div>

      {/* Navigation Controls */}
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="prev">

        <span className="carousel-control-prev-icon" aria-hidden="true">
        <span className="visually-hidden">Previous</span></span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#homeCarousel"
        data-bs-slide="next"      >
        <span className="carousel-control-next-icon" aria-hidden="true">
        <span className="visually-hidden">Next</span></span>
      </button>    
    <div className="middle">
    <p></p>
    </div>



    <section className="Out of">
    <div className="paragraph"><p>In today's stringent regulatory landscape, maintaining quality in home care
       coding and clinical documentation is paramount. Our team of certified home care 
       coders strictly follows ICD-10 CM coding guidelines and ensures HIPAA compliance 
       to minimize coding denials and demonstrate medical necessity to payers, 
       safeguarding our clients from potential revenue losses. With extensive expertise
        in OASIS documentation, ICD-10 coding, quality assurance, and compliance, our 
        professionals excel in Medicare Home Health processes, including Plan of Care, 
        Start of Care (SOC), Resumption of Care (ROC), Recertification, Discharge, and HIS.</p>
      </div>



 
    <div className="advantages-section">
      <h2 className="advantages-title">Advantages of Omega Review Solutions Pvt Ltd.</h2>
      <p className="advantages-subtitle">
        Explore the array of personalized care solutions at Omega Review Solutions, where our
        dedicated team delivers exceptional home health services customized to your needs.
      </p>
      <div className="advantages-container">
        <div className="advantage-card">
          <img src="./images/accracy.png" alt="Accuracy Icon" className="advantage-icon" />
          <h3>Accuracy and Compliance</h3>
          <p>
            Ensures accurate medical coding compliant with ICD-10 and CPT standards, vital for billing
            precision and regulatory adherence.
          </p>
        </div>
        <div className="advantage-card">
          <img src="./images/download.png" alt="Expertise Icon" className="advantage-icon" />
          <h3>Expertise and Experience</h3>
          <p>
            Utilizes skilled coders for professional service, with ongoing training to stay updated
            on coding standards.
          </p>
        </div>
        <div className="advantage-card">
          <img src="./images/images data.png" alt="Data Security Icon" className="advantage-icon" />
          <h3>Data Security and Trust</h3>
          <p>
            HIPAA compliance in medical coding ensures robust security, builds trust with clients,
            and avoids legal penalties.
          </p>
        </div>
        <div className="advantage-card">
          <img src="./images/Efficiancy.png" alt="Efficiency Icon" className="advantage-icon" />
          <h3>Efficiency and Turnaround Time</h3>
          <p>
            Speeds up billing cycles, improving cash flow for healthcare providers while boosting
            coding efficiency and accuracy.
          </p>
        </div>
      </div>
    </div>
  
  





    </section>
     </div>
      
 
  </div>
 )};

export default Carousel;
